import { render, staticRenderFns } from "./UserAccountMenu.vue?vue&type=template&id=37d5f364&scoped=true"
import script from "./UserAccountMenu.vue?vue&type=script&lang=js"
export * from "./UserAccountMenu.vue?vue&type=script&lang=js"
import style0 from "./UserAccountMenu.vue?vue&type=style&index=0&id=37d5f364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d5f364",
  null
  
)

export default component.exports